<i [@pinUnpin]="isPinned ? 'pinned' : 'unpinned'"
   class="fas fa-thumbtack"></i>
